import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/FAQ-Image.png'


const _hoisted_1 = { className: "bg-[#ffffff]" }
const _hoisted_2 = { className: "flex flex-row mx-auto max-w-7xl px-2 sm:px-6 justify-between items-center lg:px-8 sm:pt-[8rem] flex-wrap sm:pb-[6rem] pt-[6rem] pb-[4rem]" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { className: "w-full sm:w-[45%] pb-9 sm:pb-0 mr-[2rem] sm:mr-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "blockImg"
  })
], -1)
const _hoisted_4 = { className: "w-full sm:w-[49%] z-0 text-[#02021E] text-center sm:text-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { className: "sm:text-[57px] text-[20px] font-[700] leading-[57px] pb-[4rem]" }, " What people ask us frequently ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { className: "flex  text-[22px] text-[#02021E] font-[600]" }, [
  /*#__PURE__*/_createElementVNode("span", { className: "text-[white] mr-4 flex justify-center items-center bg-[#690722] rounded-[50%] w-[30px] h-[30px]" }, " ? "),
  /*#__PURE__*/_createTextVNode("Can I deposit to my wallet? ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "mb-3 text-[#617686] w-[93%] py-3 leading-[24px] text-[16px] !text-left",
    style: {"margin-inline-start":"auto"}
  }, [
    /*#__PURE__*/_createTextVNode(" You can book by signing up on our website and placing your order. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" You can track the delivery as well after order has been placed. ")
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex text-[22px] text-[#02021E] font-[600]" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "!text-left text-[white] mr-4 flex justify-center items-center bg-[#690722] rounded-[50%] w-[30px] h-[30px]" }, " ? "),
  /*#__PURE__*/_createTextVNode("How can I book a delivery? ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "mb-3 text-[#617686] w-[93%] py-3 leading-[24px] text-[16px] !text-left",
    style: {"margin-inline-start":"auto"}
  }, [
    /*#__PURE__*/_createTextVNode(" You can book by signing up on our website and placing your order. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" You can track the delivery as well after order has been placed. ")
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex text-[22px] text-[#02021E] font-[600]" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-[white] mr-4 flex justify-center items-center !text-left bg-[#690722] rounded-[50%] w-[30px] h-[30px]" }, " ? "),
  /*#__PURE__*/_createTextVNode("How do I know the cost of my delivery? ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "mb-3 text-[#617686] w-[93%] py-3 leading-[24px] text-[16px]",
    style: {"margin-inline-start":"auto"}
  }, [
    /*#__PURE__*/_createTextVNode(" You can book by signing up on our website and placing your order. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" You can track the delivery as well after order has been placed. ")
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { className: "text-[#617686] text-[17px] font-[500] mt-[3rem]" }, [
  /*#__PURE__*/_createTextVNode(" Still have questions? "),
  /*#__PURE__*/_createElementVNode("span", { className: "text-[#8E073F] font-[600]" }, "Get in touch")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_accordion_header = _resolveComponent("accordion-header")!
  const _component_accordion_content = _resolveComponent("accordion-content")!
  const _component_accordion_panel = _resolveComponent("accordion-panel")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_Accordion, { "always-open": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_accordion_panel, { class: "mb-7" }, {
              default: _withCtx(() => [
                _createVNode(_component_accordion_header, { class: "accordion_header" }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createVNode(_component_accordion_content, { class: "accordion_header" }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_accordion_panel, { class: "mb-7" }, {
              default: _withCtx(() => [
                _createVNode(_component_accordion_header, { class: "accordion_header" }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_accordion_content, { class: "accordion_header" }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_accordion_panel, { class: "mb-7" }, {
              default: _withCtx(() => [
                _createVNode(_component_accordion_header, { class: "accordion_header" }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _createVNode(_component_accordion_content, { class: "accordion_header" }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_12
      ])
    ])
  ]))
}